import React, { useContext } from 'react';
import MobileObject from './MobileObject';
import { WizardContext } from './hooks/WizardContext';
import { useSectionNameEdit } from './hooks/uiInteractions/useSectionNameEdit';
import { useSectionDnd } from './hooks/uiInteractions/useSectionDnD';
import * as S from './styles/MobileSection.styles';

const MobileSection = ({ section, index, dropIndicator, setDropIndicator }) => {
    const {
        activePage,
        selectedSectionId,
        selectSection, 
        moveSection,
        moveControl,
        renameSection,
        globalStyles
    } = useContext(WizardContext);

    const dnd = useSectionDnd({
        section, index, moveSection, moveControl, setDropIndicator, activePageId: activePage.id,
    });
    const editor = useSectionNameEdit(section, renameSection, activePage.id);

    const isSelected = section.id === selectedSectionId;
    const marginSpacing = globalStyles?.marginSpacing || 8;

    return (
        <S.SectionWrapper
            ref={dnd.ref}
            isDragging={dnd.isDragging}
            isSelected={isSelected}
            styleProps={section.attributes || {}}
            onClick={(e) => {
                e.stopPropagation();
                 selectSection(isSelected ? null : section.id);
            }}
        >
            {(section.attributes || {}).hasTitle && (
                <S.SectionHeader
                    styleProps={section.attributes || {}}
                    onDoubleClick={() => editor.setIsEditing(true)}
                >
                    {editor.isEditing ? (
                        <S.SectionHeaderInput
                            ref={editor.inputRef}
                            value={editor.name}
                            onChange={(e) => editor.setName(e.target.value)}
                            onBlur={editor.handleRename}
                            onKeyDown={editor.handleKeyDown}
                        />
                    ) : (
                        section.name
                    )}
                </S.SectionHeader>
            )}
            <S.DropArea
                ref={dnd.controlDrop}
                isOver={dnd.isOverDropArea && dropIndicator?.targetId === section.id}
                styleProps={section.attributes || {}}
                marginSpacing={marginSpacing}
            >
                {section.controls.length > 0 ? (
                    section.controls.map((control, i) => (
                        <MobileObject
                            key={control.id}
                            index={i}
                            sectionId={section.id}
                            control={control}
                            dropIndicator={dropIndicator}
                            setDropIndicator={setDropIndicator}
                        />
                    ))
                ) : (
                    <span>Drop controls here...</span>
                )}
            </S.DropArea>
        </S.SectionWrapper>
    );
};

export default MobileSection;